import React, { useState } from 'react';

import { getCookie } from 'functions/getCookie';
import { getConfig } from 'functions/getConfig';
import { RoundIconButton } from 'components/Button/IconButton';
import { buttonIds } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';
import Tour from 'components/Tour/Tour';
import TOUR_DATA from './tourDataFreecode';

export default function TourButton({ layout }) {
  const [completed, setCompleted] = useState(getCookie('fsFreecodeTourDone'));

  const setTourCookie = (value) =>
    (document.cookie = `fsFreecodeTourDone=${value}; Domain=${
      getConfig().COOKIE
    }; Max-Age=31536000; Path=/; SameSite=Lax`);

  const toggleTour = (newValue) => {
    setCompleted(newValue);
    if (newValue) {
      setTourCookie(true);
    } else {
      setTourCookie('');
    }
  };

  return (
    <>
      <RoundIconButton
        icon="fa fa-question"
        id={buttonIds.helpButton}
        title="Toggle the editor tour"
        onClick={() => toggleTour(!completed)}
      />
      {!completed && (
        <Tour tourData={TOUR_DATA} completed={completed} setCompleted={() => toggleTour(!completed)} layout={layout} />
      )}
    </>
  );
}
